import './ProtectionSettings.css';
import Lottie from 'react-lottie';
import animationData from './animation/Settings-gradient-hover-mechanic.json'

const ProtectionSettings = ()=>{

    const defaultOptions = {
        loop: true,          // Whether the animation should loop
        autoplay: true,      // Whether the animation should play automatically
        animationData: animationData, // Your downloaded Lottie JSON file
      };
    return(
        <>
        <section className='protectionSettingsMain' id='CoverageSettings'>
            <img className="primary_3" src="/img/rentshield/primary_3.png" alt="rent id"/>
            <div className='container'>
                <div className='row justify-content-center'>
                    <div className='col-lg-7 col-md-12 col-sm-12 col-12'>
                        <div className='protectionSettingshead'>
                            <h2>Customize every aspect of your <span> coverage & protection settings</span></h2>
                            <p>Easily adjust settings to define coverage responsibilities, manage protection fees, 
                            and decide actions for declined protection plans, giving you full control to tailor 
                            operations and protection settings seamlessly to your business needs and preferences.</p>
                        </div>
                    </div>
                </div>
                <div className='row justify-content-center'>
                    <div className='col-lg-12 col-md-12 col-sm-12 col-12'>
                        <div className='protectionSettingsInner'>
                        <span><Lottie options={defaultOptions}   /></span>
                            <img className="img-fluid" src="/img/rentshield/protectionSettings.png" alt="rent id"/>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        </>
    )
}

export default ProtectionSettings;